import { DocumentReference } from "@firebase/firestore-types";
import firebase from "firebase/compat/app";
import { User } from "./User";
import Customer from "./Customer";
import { Collaboration } from "./Chat";

/**
 * Media information for messages (new nested structure)
 * Mirrors server-side MediaInfo in messageModel.v3.ts
 */
export interface MediaInfo {
  url: string;
  originalUrl?: string;
  mimeType?: string;
  filename?: string;
  extension?: string;
  duration?: string; // For audio/video (format: "MM:SS")
  size?: number;
  fileRecordId?: string; // Reference to FileRecord document ID
}

export default interface Message {
  client?: firebase.firestore.DocumentReference;
  channel: string;
  destination:
    | DestinationStatus["inbound"]
    | DestinationStatus["outbound"]
    | DestinationStatus["blast"];
  createdAt: firebase.firestore.Timestamp;
  customer?: DocumentReference;
  customerPhoneNumber?: string;
  conversation?: firebase.firestore.DocumentReference;
  conversationId?: string;
  // user?: DocumentReference;
  user?: Array<any>;
  customerModel?: Customer;
  userModel?: User;
  mediaUrl?: string;
  messageType: string | undefined;
  textContent: string;
  updatedAt: firebase.firestore.Timestamp;
  id?: string;
  status?: string;
  resultCode?: string;
  resultMessage?: string;
  errorCode?: string;
  errorDetail?: any;
  errorTitle?: string;
  resultMessageId?: string;
  error?: {
    errorCode?: string;
    errorMessage?: string;
  };
  responseJson?: string;
  responseCode?: string;
  previewurl?: boolean;
  collaboration?: DocumentReference;
  isActive: boolean;
  filename?: string;
  filesize?: string;
  fileId?: string;
  voice: boolean;
  templateName?: string;
  templateLanguage?: string;
  header?: string;
  headerUrl?: string;
  headerParams?: Array<string>;
  body?: string;
  bodyParams?: Array<string>;
  footer?: string;
  buttons?: string[];
  location?: {
    latitude: number;
    longitude: number;
    locationName?: string;
    locationAddress?: string;
    geoLocation?: firebase.firestore.GeoPoint;
  };
  media?: MediaInfo; // NEW: Nested media object (like location)
  collaborationModel?: Collaboration;
  submittedAt?: firebase.firestore.Timestamp;
  sentAt?: firebase.firestore.Timestamp;
  deliveredAt?: firebase.firestore.Timestamp;
  failedAt?: firebase.firestore.Timestamp;
  readAt?: firebase.firestore.Timestamp;
  fromUser?: DocumentReference;
  toUser?: DocumentReference;
  notifiedAt?: firebase.firestore.Timestamp | null;
  ttl?: firebase.firestore.Timestamp | null;
  isMessageRead?: boolean;
  messageId?: string;
  replyMessageID?: DocumentReference;
  company?: DocumentReference;
  order?: DocumentReference;
  orderSN?: string;
  duration?: string;
  interactive?: InteractiveMessage;
  conversation_category?: string;
  oldCost?: number;
  newCost?: number;
  room: firebase.firestore.DocumentReference;
  product?: Product;
  source?: string;
}

export interface ProductVariant {
  sku: string;
  name: string;
  price?: string;
  imageUrl?: string;
  stock?: number;
  attributes?: Record<string, string>;
}

export interface Product {
  displayName?: string;
  displayPrice?: string;
  imageUrl?: string;
  marketplaceProductId?: number;
  url?: string;
  sku?: string;
  stock?: number;
  variants?: ProductVariant[];
}

export interface InteractiveMessage {
  type: string;
  components: Array<InteractiveMessageComponent>;
}

export interface InteractiveMessageComponent {
  type: string;
  text?: string;
  buttons?: InteractiveMessageButton[];
  document?: string;
  image?: string;
  video?: string;
  filename?: string;
}

export interface InteractiveMessageButton {
  id: string;
  title: string;
}

export const MessageStatus = {
  sent: "sent", //ceklis 1
  submitted: "submitted", //pending
  delivered: "delivered", //ceklis 2
  failed: "failed", //merah
  read: "read", //ceklis 2 biru
  rejected: "rejected",
};

export type DestinationStatus = {
  inbound: "inbound";
  outbound: "outbound";
  blast: "blast";
};
